import type { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/components/Tooltip';
import { cssVariable } from 'app/utils/style';
import { round } from 'app/utils/number';
import { getCDNUrl } from 'app/utils/api_url';

import style from './style.module.scss';

interface Props {
  heroes: HeroWinrate[];
  teamIndex: 0 | 1;
  orientation: 'horizontal' | 'vertical';
}

const HeroDraft: FC<Props> = ({ heroes, teamIndex, orientation }) => {
  const { t } = useTranslation();
  const vertical = orientation === 'vertical';
  // Point the hero-name tooltip inward (team 1 = right, team 2 = left) so it
  // opens over the roomy center carousel instead of the tight widget edges.
  // flip()/shift() inside Tooltip auto-correct if there's no room.
  const tooltipPosition: Position = teamIndex === 0 ? 'right' : 'left';

  return (
    <div
      className={classNames(style.draft, teamIndex === 0 ? style.team1 : style.team2, {
        [style.vertical]: vertical
      })}
    >
      <div className={classNames(style.heroes, vertical ? style.heroesCol : style.heroesRow)}>
        {heroes?.map((hero, index) => (
          <div key={`${hero.id}_${index}`} className={style.heroCard}>
            <Tooltip
              content={hero.name}
              position={tooltipPosition}
              className={style.heroTooltip}
              withPortal
            >
              <span
                className={style.portrait}
                style={cssVariable('hero', `url(${getCDNUrl(hero.image_url)})`)}
              >
                <span className={style.tint} />
              </span>
            </Tooltip>
            <span className={style.winrate}>
              {hero.winrate !== null ? `${round(hero.winrate * 100, 0)}%` : '—'}
            </span>
          </div>
        ))}
      </div>
      <span className={style.caption}>{t('block-grad-name-3_month_winrate')}</span>
    </div>
  );
};

HeroDraft.displayName = 'HeroDraft';

export default HeroDraft;
